// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Checkbox } from '@carbon/react';
import styled from '@emotion/styled';
import { func, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
import FilterListComponent from 'Components/Filters/FilterListComponent';

const StyledFilter = styled.div`
  .localStockInfo {
    font-size: 12px;
    color: #707070;
    margin-left: 10px;
  }
`;

const StockLocationFilter = ({
  open,
  onToggle,
  onOnlyWarehouseChange,
  onlyWarehouse,
}) => {
  const { t } = useTranslation();
  return (
    <FilterListComponent
      onToggle={ onToggle }
      filterTitle={ t('filters.stockLocation') }
      cx={ open ? 'open' : 'closed' }
      showSearch={ false }
    >
      <StyledFilter className="options">
        <div className="filterItem">
          <Checkbox
            id="localStock"
            name="localStock"
            labelText={ t('filters.localStock') }
            checked={ onlyWarehouse }
            onChange={ (_, { checked }) => onOnlyWarehouseChange(checked) }
          />
          <span className="localStockInfo">({ t('filters.withoutSupplierStock') })</span>
        </div>
      </StyledFilter>
    </FilterListComponent>
  );
};

StockLocationFilter.propTypes = {
  onToggle: func,
  onOnlyWarehouseChange: func,
  onlyWarehouse: bool,
  open: bool
};

export default StockLocationFilter;
